module.exports = __webpack_public_path__ + "static/media/SD.3092b2a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SD.svg
// module id = 354
// module chunks = 0